<template>
  <Navbar>
    <template v-slot:navbarTitle>製品検査</template>
  </Navbar>

  <main id="main" class="container-fluid pt-3">
    <div class="d-flex gap-2 mb-3">
      <h5 class="m-0 p-0"><i class="bi bi-folder me-1"></i>中断理由一覧</h5>
      <div class="ms-auto">
        <a
          v-on:click.prevent="showInspectionReasonInterruptedForm()"
          class="btn btn-primary"
        >
          <span class="d-block d-sm-none"><i class="bi bi-plus-lg"></i></span>
          <span class="d-none d-sm-block"
            ><i class="bi bi-plus-lg me-1"></i>中断理由を追加する</span
          >
        </a>
      </div>
    </div>

    <div class="d-flex justify-content-end gap-2 mb-2">
      <Pagination :prev="prev" :next="next" @move-page="movePage" />
    </div>

    <!-- results -->
    <div v-if="results && results.length > 0">
      <data-table :headers="headers" :items="results">
        <template #is_active="{ item }">
          <active-status :is_active="item.is_active" />
        </template>
        <template #actions="{ item }">
          <a
            href="#"
            v-on:click.prevent="showInspectionReasonInterruptedForm(item)"
            class="text-success text-decoration-none"
            >編集</a
          >｜<a
            v-on:click.prevent="removeData(item)"
            href="#"
            class="text-danger text-decoration-none"
            >削除</a
          >
        </template>
      </data-table>
    </div>
    <p v-else class="mt-3">該当するデータはありません。</p>
    <DeleteDialog ref="confirmDataDelete" @confirm-true="confirmDataDelete" />

    <InspectionReasonInterruptedForm ref="interruptedReasonForm" />
  </main>
</template>

<script>
import DeleteDialog from '@/components/AppDeleteDialog.vue'
import Pagination from '@/components/AppNoCountPagination.vue'
import DataTable from '@/components/common/DataTable.vue'
import Navbar from '@/components/Navbar.vue'
import ActiveStatus from '@/components/TheActiveStatus.vue'
import InspectionReasonInterruptedForm from '../components/InspectionReasonInterruptedForm.vue'
import store from '../store'

export default {
  name: 'ManageInspectionReasonInterrupted',
  components: {
    Navbar,
    Pagination,
    DeleteDialog,
    DataTable,
    ActiveStatus,
    InspectionReasonInterruptedForm,
  },

  data() {
    return {
      current_id: null,
      query: {},
      headers: [
        {
          key: 'reason',
          label: '中断理由',
          class: 'col-5',
          format: 'string',
        },
        {
          key: 'is_active',
          label: '有効',
          class: 'col-1',
          format: 'status',
        },
        {
          key: 'created_at',
          label: '作成日時',
          class: 'col-2',
          format: 'datetime',
        },
        {
          key: 'updated_at',
          label: '更新日時',
          class: 'col-2',
          format: 'datetime',
        },
        {
          key: 'actions',
          label: '',
          class: 'col-2',
          format: 'actions',
        },
      ],
    }
  },
  computed: {
    results() {
      return store.getters['inspection_reason_interrupted/results']
    },
    prev() {
      return store.getters['inspection_reason_interrupted/prev']
    },
    next() {
      return store.getters['inspection_reason_interrupted/next']
    },
  },

  async created() {
    await this.getData()
  },

  mounted() {
    window.scrollTo(0, 0)
  },

  methods: {
    getData(query = {}) {
      return store.dispatch('inspection_reason_interrupted/fetchAll', query)
    },
    deleteData(id) {
      return store.dispatch('inspection_reason_interrupted/deleteData', id)
    },
    movePage(page) {
      this.getData(Object.assign(this.query, { page: page }))
    },
    showInspectionReasonInterruptedForm(formData) {
      this.$refs.interruptedReasonForm.show(formData)
    },
    removeData(object) {
      this.currentId = object.id
      this.$refs.confirmDataDelete.showDialog(
        '中断理由データ',
        object.reason,
      )
    },
    async confirmDataDelete() {
      try {
        await this.deleteData(this.currentId)
      } catch (e) {
        let message = '削除できませんでした。'
        if (e.response.status === 409) {
          message = 'この中断は使用しています。'
        }
        this.$store.dispatch('alert/setErrorMessage', {
          message: message,
        })
      }
      this.currentId = null
    },
  },
}
</script>
